export default __webpack_public_path__ + "static/media/Truly_Logo_GreenSvg.d6810670.svg";